import React, { useState, useEffect } from "react"
import axios from "axios"
import { BASE_URL } from "../../../Util/requests"
import Questionnaire from "../../../Components/Questionnaire"
import CstCsosnCfop from "../"
import image_add from "../../../Images/Buttons/add.png"
import image_delete from "../../../Images/Buttons/cancel.png"
import image_loading from "../../../Images/spinner.gif";
import image_select from "../../../Images/Buttons/select_circle.png"

const SearchCstCsosnCfop = ({databaseType, databasePath, jsonCstCsosn, jsonLogin, jsonCompany, system, showMenu, width}) => {
  const [code, setCode] = useState(0)  
  const [update, setUpdate] = useState(0)
  const [showChange, setShowChange] = useState(false)

  const [jsonCstCsosnCfop, setJsonCstCsosnCfop] = useState("")

  const [result, setResult] = useState({})
  const [loading, setLoading] = useState("")
  const [warning, setWarning] = useState("")
  const [error, setError] = useState("")

  const [askQuestionnaire, setAskQuestionnaire] = useState("")
  const [showQuestionnaire, setShowQuestionnaire] = useState(false)

  useEffect(() => {
    let returnJson = []

    setLoading("Aguarde buscando as informações...")
    setWarning("")
    setError("")

    const jCstCsosnCfop = "{ \"CST_CSOSN\": { \"CODE\": \""+ jsonCstCsosn.CODE +"\", \"DESCRIPTION\": \""+ jsonCstCsosn.DESCRIPTION +
      "\", \"COMPANY\": { \"ID\": "+ jsonCstCsosn.COMPANY.ID + " } } }"

    const formData = new FormData()
    formData.append("DATABASE_TYPE", databaseType)
    formData.append("DATABASE_PATH", databasePath)
    formData.append("JSON_NEW_1", jCstCsosnCfop)
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
    formData.append("SYSTEM", system)

    axios.post(BASE_URL + "CST_CSOSN_CFOP/Search", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
    ", \"ERROR\": \"Não foi possível pesquisar os CSTs/CSOSNs dos CFOPs. ("+ response +")\" }") })
    .finally(() => {
      if (returnJson.CONCRETIZADO === false){
        setError(returnJson.ERROR)
        setLoading("")
        return
      }

      setResult(returnJson)
      setLoading("")
    })
  }, [databaseType, databasePath, jsonCstCsosn, jsonLogin, system, update])

  const add = () => {
    setJsonCstCsosnCfop(JSON.parse("{ \"CST_CSOSN\": { \"CODE\": \""+ jsonCstCsosn.CODE +"\", \"DESCRIPTION\": \""+ jsonCstCsosn.DESCRIPTION +
      "\", \"COMPANY\": { \"ID\": "+ jsonCstCsosn.COMPANY.ID + " } } }"))

    setWarning("")
    setError("")
    setShowChange(true)
  }

  const back = () => {
    setWarning("")
    setError("")
    setShowChange(false)
  }  

  const callDelete = (item) => {
    setCode(item.ID)
    setAskQuestionnaire("Deseja realmente excluir o CFOP (" + item.CFOP.ID + ") ?")
    setShowQuestionnaire(true)
  }

  const cancelDelete = () => {
    setShowQuestionnaire(false)
    setCode(0)
  }

  const confirmDelete = () => {
    let returnJson = []
    const jCstCsosnCfop = "{ \"ID\": "+ code +", \"CST_CSOSN\": { \"COMPANY\": { \"ID\": "+ jsonCompany.ID +" } } }"

    setLoading("Aguarde excluido o CFOP...")
    setWarning("")
    setError("")

    const formData = new FormData()
    formData.append("DATABASE_TYPE", databaseType)
    formData.append("DATABASE_PATH", databasePath)
    formData.append("JSON_NEW_1", jCstCsosnCfop)
    formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
    formData.append("SYSTEM", system)

    axios.post(BASE_URL + "CST_CSOSN_CFOP/Delete", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
    ", \"ERROR\": \"Não foi possível excluir o CST/CSOSN do CFOP. ("+ response +")\" }") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setShowQuestionnaire(false)
        setCode(0)
        setLoading("")

        return
      }

      returnJson.WARNING && setWarning(returnJson.WARNING)

      setShowQuestionnaire(false)
      setCode(0)
      setLoading("")

      const count = update + 1
      setUpdate(count)
    })
  }

  const save = (cstCsosnCfop) => {
    let returnJson = []
    const json = JSON.parse(cstCsosnCfop)

    if (json.ID === undefined)
    {
      setLoading("Aguarde incluindo o CFOP...")
      setWarning("")
      setError("")

      const formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_NEW_1", cstCsosnCfop)
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
      formData.append("SYSTEM", system)
      formData.append("GET_ID", true)

      axios.post(BASE_URL + "CST_CSOSN_CFOP/Insert", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível incluir o CST/CSOSN do CFOP. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          return
        }

        returnJson.WARNING ? setWarning("Inclusão efetuada com sucesso! ("+ returnJson.WARNING +")")
        : setWarning("Inclusão efetuada com sucesso!")

        setLoading("")
        setError("")
        setShowChange(false)

        const count = update + 1
        setUpdate(count)
      })
    }
    else
    {
      setLoading("Aguarde alterando o CFOP...")
      setWarning("")
      setError("")

      const formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_OLD", JSON.stringify(jsonCstCsosnCfop))
      formData.append("JSON_NEW_1", cstCsosnCfop)
      formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("SYSTEM", system)

      axios.put(BASE_URL + "CST_CSOSN_CFOP/Update", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível alterar o CST/CSOSN do CFOP. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          return
        }

        returnJson.WARNING ? setWarning("Alteração efetuada com sucesso! ("+ returnJson.WARNING +")")
        : setWarning("Alteração efetuada com sucesso!")

        setLoading("")
        setError("")
        setShowChange(false)

        const count = update + 1
        setUpdate(count)
      })
    }
  }

  const setSelected = (cstCsosnCfop) => {
    setJsonCstCsosnCfop(cstCsosnCfop)
    setWarning("")
    setError("")
    setShowChange(true)
  }

  return(
    <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginBottom: 10}
      : {display: "flex", flexDirection: "column", flexGrow: 0, paddingLeft: 10, paddingRight: 10, marginBottom: 10}}>

      { loading ?
          <div style={{display: "flex", flexDirection: "column", flexGrow: 0, justifyContent: "center", alignItems: "center", marginTop: 10,
            marginBottom: 10}}>
            <img style={{marginBottom: 10, height: 32, width: 32}} src={image_loading} alt="Carregando"/>
            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{loading}</label>
          </div>
        :
        <>
          { warning && 
            <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10, marginBottom: 10}}>
              <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
            </div> 
          }

          { error &&
            <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10, marginBottom: 10}}>
              <label style={{fontWeight: 600, color: "red"}}>{error}</label>
            </div>
          }

          { showChange ?
              <CstCsosnCfop
                databaseType={databaseType}
                databasePath={databasePath}
                jsonCstCsosnCfop={jsonCstCsosnCfop}
                setJsonCstCsosnCfop={setJsonCstCsosnCfop}
                jsonCompany={jsonCompany}
                jsonLogin={jsonLogin}
                system={system}
                save={save}
                back={back} 
                showMenu={showMenu}
                width={width} />
            :
              <>
                { showQuestionnaire ?
                    <div style={{marginTop: 10}}>
                      <Questionnaire
                        ask={askQuestionnaire}
                        setConfirm={() => confirmDelete()}
                        setCancel={() => cancelDelete()} />
                    </div>
                  :
                    <>
                      <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 5,
                          marginLeft: 5, width: 147}} onClick={() => add()}>
                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5,
                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                            <img style={{height: 32, width: 32}} src={image_add} alt="Novo"/>
                          </div>
                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Novo</label>
                          </div>
                        </div>
                      </div>

                      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div style={{backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10, width: "98%"}} />
                      </div>

                      <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5}
                        : {paddingLeft: 10, paddingRight: 10}}>

                        { result.OBJECT ?
                            <>
                              <div style={(width < 480) ?
                                  {display: "flex", flexDirection: "column", flexGrow: 1,
                                    borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                    marginTop: 30, marginBottom: 4}
                                :
                                  {display: "flex", flexDirection: "row", flexGrow: 1,
                                    borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                    marginTop: 30, marginBottom: 4}}>

                                <div style={{display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 10}}>
                                  <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                    <label style={{fontWeight: 600}}>CFOP</label>
                                  </div>

                                  <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                    <div style={(showMenu) ?
                                        (width < 1080) ? {display: "flex", flexGrow: 1, flexDirection: "column"}
                                        : {display: "flex", flexGrow: 1, flexDirection: "row"}
                                      : 
                                        (width < 690) ? {display: "flex", flexGrow: 1, flexDirection: "column"}
                                        : {display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                  
                                      <div style={(showMenu) ?
                                          (width < 1080) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}
                                        : 
                                          (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                                        <label style={{fontWeight: 600}}>Tipo Produto</label>
                                      </div>
                                      <div style={(showMenu) ?
                                          (width < 1080) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}
                                        : 
                                          (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                                        <label style={{fontWeight: 600}}>Tipo Cliente</label>
                                      </div>
                                    </div>

                                    { showMenu && (width >= 1600) &&
                                      <div style={{display: "flex", flexGrow: 0, flexDirection: "row"}}>
                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>Primário</label>
                                        </div>

                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>ST</label>
                                        </div>

                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>ICMS</label>
                                        </div>
                                      
                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>DIFAL</label>
                                        </div>

                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>IPI</label>
                                        </div>
                                      </div>
                                    }

                                    { showMenu && (width < 1600) && (width >= 840) &&
                                      <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>Primário</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>ST</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>ICMS</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>DIFAL</label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>IPI</label>
                                          </div>
                                        </div>
                                      </div>
                                    }

                                    { showMenu && (width < 840) && (width >= 500) &&
                                      <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label style={{fontWeight: 600}}>Primário</label>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label style={{fontWeight: 600}}>ST</label>
                                          </div>
                                        </div>
                                        
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label style={{fontWeight: 600}}>ICMS</label>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label style={{fontWeight: 600}}>DIFAL</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <label style={{fontWeight: 600}}>IPI</label>
                                        </div>
                                      </div>
                                    }

                                    { !showMenu && (width >= 720) &&
                                      <div style={{display: "flex", flexGrow: 0, flexDirection: "row"}}>
                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>Primário</label>
                                        </div>
                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>ST</label>
                                        </div>
                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>ICMS</label>
                                        </div>                                      
                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>DIFAL</label>
                                        </div>
                                        <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                          <label style={{fontWeight: 600}}>IPI</label>
                                        </div>
                                      </div>
                                    }

                                    { !showMenu && (width < 720) && (width >= 540) &&
                                      <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>Primário</label>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>ST</label>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>ICMS</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>DIFAL</label>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label style={{fontWeight: 600}}>IPI</label>
                                          </div>
                                        </div>
                                      </div>
                                    }

                                    { !showMenu && (width < 540) && (width >= 500) &&
                                      <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label style={{fontWeight: 600}}>Primário</label>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label style={{fontWeight: 600}}>ST</label>
                                          </div>
                                        </div>
                                        
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label style={{fontWeight: 600}}>ICMS</label>
                                          </div>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label style={{fontWeight: 600}}>DIFAL</label>
                                          </div>
                                        </div>

                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <label style={{fontWeight: 600}}>IPI</label>
                                        </div>
                                      </div>
                                    }

                                    { (width < 500) &&
                                      <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <label style={{fontWeight: 600}}>Primário</label>
                                        </div>
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <label style={{fontWeight: 600}}>ST</label>
                                        </div>                                        
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <label style={{fontWeight: 600}}>ICMS</label>
                                        </div>
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <label style={{fontWeight: 600}}>DIFAL</label>
                                        </div>
                                        <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                          <label style={{fontWeight: 600}}>IPI</label>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </div>

                                { (width >= 480) &&
                                  <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 100, maxWidth: 100}}>
                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minHeight: 32, minWidth: 32,
                                      maxWidth: 32}} />

                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minHeight: 32, minWidth: 32,
                                      maxWidth: 32}}/>
                                  </div>
                                }
                              </div>

                              <div style={showMenu ? 
                                  {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32,
                                    maxWidth: 32}
                                  : (width < 330) ? {display: "flex", flexGrow: 0, alignItems: "center", marginTop: 10, minWidth: 32, maxWidth: 32}
                                : {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}} />

                              { result.OBJECT.map(item => (
                                <div key={item.ID} style={(width < 480) ?
                                    {display: "flex", flexDirection: "column", flexGrow: 1,
                                    backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                    borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                    marginTop: 4, minWidth: 180}
                                  : 
                                    {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                    backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                    borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                    marginTop: 4, minWidth: 180}}>

                                  <div style={{display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 10}}>
                                    <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                      <label>{item.CFOP.ID + " - " + item.CFOP.DESCRIPTION}</label>
                                    </div>

                                    <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                      <div style={(showMenu) ?
                                          (width < 1080) ? {display: "flex", flexGrow: 1, flexDirection: "column"}
                                          : {display: "flex", flexGrow: 1, flexDirection: "row"}
                                        : 
                                          (width < 690) ? {display: "flex", flexGrow: 1, flexDirection: "column"}
                                          : {display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                    
                                        <div style={(showMenu) ?
                                            (width < 1080) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                            : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}
                                          : 
                                            (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                            : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                                          <label>
                                            { (item.PRODUCT_TYPE === 1) && "Industrialização" }
                                            { (item.PRODUCT_TYPE === 2) && "Revenda" }
                                            { (item.PRODUCT_TYPE === 3) && "Consumo" }
                                            { (item.PRODUCT_TYPE === 4) && "Serviço" }
                                            { (item.PRODUCT_TYPE === 5) && "Combustível" }
                                            { (item.PRODUCT_TYPE === 6) && "Embalagem" }
                                            { (item.PRODUCT_TYPE === 7) && "Materia" }
                                            { (item.PRODUCT_TYPE === 8) && "Ativo Imobilizado" }
                                            { (item.PRODUCT_TYPE === 9) && "Outros insumos" }
                                            { (item.PRODUCT_TYPE === 10) && "Outras" }
                                            { (item.PRODUCT_TYPE === 11) && "Revenda (Substituto)" }
                                          </label>
                                        </div>
                                        <div style={(showMenu) ?
                                            (width < 1080) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                            : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}
                                          : 
                                            (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                            : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                                          <label>
                                            { (item.CLIENT_TYPE === 1) && "Consumidor" }
                                            { (item.CLIENT_TYPE === 2) && "Revendedor" }
                                          </label>
                                        </div>
                                      </div>

                                      { showMenu && (width >= 1600) &&
                                        <div style={{display: "flex", flexGrow: 0, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.PRIMARY === 1) && "Sim" }
                                              { (item.PRIMARY === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.HIGHLIGHT_ST === 1) && "Sim" }
                                              { (item.HIGHLIGHT_ST === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.HIGHLIGHT_ICMS === 1) && "Sim" }
                                              { (item.HIGHLIGHT_ICMS === 2) && "Não" }
                                            </label>
                                          </div>
                                        
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.HIGHLIGHT_DIFAL === 1) && "Sim" }
                                              { (item.HIGHLIGHT_DIFAL === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.HIGHLIGHT_IPI === 1) && "Sim" }
                                              { (item.HIGHLIGHT_IPI === 2) && "Não" }
                                            </label>
                                          </div>
                                        </div>
                                      }

                                      { showMenu && (width < 1600) && (width >= 840) &&
                                        <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.PRIMARY === 1) && "Sim" }
                                                { (item.PRIMARY === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.HIGHLIGHT_ST === 1) && "Sim" }
                                                { (item.HIGHLIGHT_ST === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.HIGHLIGHT_ICMS === 1) && "Sim" }
                                                { (item.HIGHLIGHT_ICMS === 2) && "Não" }
                                              </label>
                                            </div>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.HIGHLIGHT_DIFAL === 1) && "Sim" }
                                                { (item.HIGHLIGHT_DIFAL === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.HIGHLIGHT_IPI === 1) && "Sim" }
                                                { (item.HIGHLIGHT_IPI === 2) && "Não" }
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      }

                                      { showMenu && (width < 840) && (width >= 500) &&
                                        <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                              <label>
                                                { (item.PRIMARY === 1) && "Sim" }
                                                { (item.PRIMARY === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                              <label>
                                                { (item.HIGHLIGHT_ST === 1) && "Sim" }
                                                { (item.HIGHLIGHT_ST === 2) && "Não" }
                                              </label>
                                            </div>
                                          </div>
                                          
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                              <label>
                                                { (item.HIGHLIGHT_ICMS === 1) && "Sim" }
                                                { (item.HIGHLIGHT_ICMS === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                              <label>
                                                { (item.HIGHLIGHT_DIFAL === 1) && "Sim" }
                                                { (item.HIGHLIGHT_DIFAL === 2) && "Não" }
                                              </label>
                                            </div>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label>
                                              { (item.HIGHLIGHT_IPI === 1) && "Sim" }
                                              { (item.HIGHLIGHT_IPI === 2) && "Não" }
                                            </label>
                                          </div>
                                        </div>
                                      }

                                      { !showMenu && (width >= 720) &&
                                        <div style={{display: "flex", flexGrow: 0, flexDirection: "row"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.PRIMARY === 1) && "Sim" }
                                              { (item.PRIMARY === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.HIGHLIGHT_ST === 1) && "Sim" }
                                              { (item.HIGHLIGHT_ST === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.HIGHLIGHT_ICMS === 1) && "Sim" }
                                              { (item.HIGHLIGHT_ICMS === 2) && "Não" }
                                            </label>
                                          </div>
                                        
                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.HIGHLIGHT_DIFAL === 1) && "Sim" }
                                              { (item.HIGHLIGHT_DIFAL === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                            <label>
                                              { (item.HIGHLIGHT_IPI === 1) && "Sim" }
                                              { (item.HIGHLIGHT_IPI === 2) && "Não" }
                                            </label>
                                          </div>
                                        </div>
                                      }

                                      { !showMenu && (width < 720) && (width >= 540) &&
                                        <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.PRIMARY === 1) && "Sim" }
                                                { (item.PRIMARY === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.HIGHLIGHT_ST === 1) && "Sim" }
                                                { (item.HIGHLIGHT_ST === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.HIGHLIGHT_ICMS === 1) && "Sim" }
                                                { (item.HIGHLIGHT_ICMS === 2) && "Não" }
                                              </label>
                                            </div>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.HIGHLIGHT_DIFAL === 1) && "Sim" }
                                                { (item.HIGHLIGHT_DIFAL === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexBasis: 1}}>
                                              <label>
                                                { (item.HIGHLIGHT_IPI === 1) && "Sim" }
                                                { (item.HIGHLIGHT_IPI === 2) && "Não" }
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      }

                                      { !showMenu && (width < 540) && (width >= 500) &&
                                        <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                              <label>
                                                { (item.PRIMARY === 1) && "Sim" }
                                                { (item.PRIMARY === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                              <label>
                                                { (item.HIGHLIGHT_ST === 1) && "Sim" }
                                                { (item.HIGHLIGHT_ST === 2) && "Não" }
                                              </label>
                                            </div>
                                          </div>
                                          
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                              <label>
                                                { (item.HIGHLIGHT_ICMS === 1) && "Sim" }
                                                { (item.HIGHLIGHT_ICMS === 2) && "Não" }
                                              </label>
                                            </div>

                                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                              <label>
                                                { (item.HIGHLIGHT_DIFAL === 1) && "Sim" }
                                                { (item.HIGHLIGHT_DIFAL === 2) && "Não" }
                                              </label>
                                            </div>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label>
                                              { (item.HIGHLIGHT_IPI === 1) && "Sim" }
                                              { (item.HIGHLIGHT_IPI === 2) && "Não" }
                                            </label>
                                          </div>
                                        </div>
                                      }

                                      { (width < 500) &&
                                        <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label>
                                              { (item.PRIMARY === 1) && "Sim" }
                                              { (item.PRIMARY === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label>
                                              { (item.HIGHLIGHT_ST === 1) && "Sim" }
                                              { (item.HIGHLIGHT_ST === 2) && "Não" }
                                            </label>
                                          </div>
                                          
                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label>
                                              { (item.HIGHLIGHT_ICMS === 1) && "Sim" }
                                              { (item.HIGHLIGHT_ICMS === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label>
                                              { (item.HIGHLIGHT_DIFAL === 1) && "Sim" }
                                              { (item.HIGHLIGHT_DIFAL === 2) && "Não" }
                                            </label>
                                          </div>

                                          <div style={{display: "flex", flexGrow: 1, flexDirection: "row"}}>
                                            <label>
                                              { (item.HIGHLIGHT_IPI === 1) && "Sim" }
                                              { (item.HIGHLIGHT_IPI === 2) && "Não" }
                                            </label>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>

                                  <div style={(width < 480) ? {display: "flex", flexGrow: 0, alignItems: "center", marginTop: 10,
                                      justifyContent: "center"}
                                    : {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 90, maxWidth: 90}}>

                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}}>
                                      <img
                                        style={{height: 32, width: 32}}
                                        src={image_select}
                                        name="searchCstCsosnCfopSelected"
                                        alt="Selecionar"
                                        onClick={(() => setSelected(item))} />
                                    </div>

                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}}>
                                      <img
                                        style={{height: 28, width: 28}}
                                        src={image_delete}
                                        name="searchCstCsosnCfopDeleted"
                                        alt="Deletar"
                                        onClick={() => callDelete(item)} />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </>
                          :
                            <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", marginTop: 10,
                              marginBottom: 10}}>
                              <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>Nenhum registro encontrado.</label>
                            </div>
                        }
                      </div>
                    </>
                }
              </>
          }
        </>
      }
    </div>
  )
}

export default SearchCstCsosnCfop